'use client';
import { Search as MoonSearch } from '@heathmont/moon-core-tw';

const SearchInput = MoonSearch.Input.Input as React.FC<
  React.InputHTMLAttributes<HTMLInputElement>
>;

const Input = Object.assign(MoonSearch.Input, { Input: SearchInput });

const Search = Object.assign(MoonSearch, { Input });

export default Search;
